import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowDown16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.74994 11.9038L12.6126 8.04108L13.6733 9.10174L8.00009 14.7749L2.3269 9.10174L3.38757 8.04108L7.24994 11.9035L7.24994 1.14288H8.74994L8.74994 11.9038Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowDown16.displayName = 'ArrowDown16';
export default ArrowDown16;
